module.exports = __webpack_public_path__ + "static/dance.8a3674e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/cabinet/desc/dance.jpg
// module id = 86
// module chunks = 27823797070795 88197199937824 213720915766396